import jquery from 'jquery';
window.jQuery = window.$ = jquery;

// Bootstrap Framework
import './scss/index.scss';
import '@popperjs/core';
import 'bootstrap';
// Slick
import 'slick-carousel';
// bootbox
import bootbox from 'bootbox';

//import hcSticky from 'hc-sticky';
//import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

//#region bootstrap navbar + hamburger + body scroll lock
/*
var navbarMain = document.getElementById('navbarMain');
navbarMain.addEventListener('show.bs.collapse', function () {
  $('.navbar-toggler .hamburger').addClass('is-active');
  let scrollableNav = document.querySelector('#navbarMain');
  disableBodyScroll(scrollableNav);
});
navbarMain.addEventListener('hidden.bs.collapse', function () {
  $('.navbar-toggler .hamburger').removeClass('is-active');
  let scrollableNav = document.querySelector('#navbarMain');
  enableBodyScroll(scrollableNav);
});
*/
//#endregion

//#region stickybar
/*
document.addEventListener('DOMContentLoaded', function () {
  new hcSticky('.stickybar', {
    stickTo: 'body',
    stickyClass: 'stickybar--sticked',
  });
});
*/
//#endregion

function trigger(e, o, c) {
  $(document).off(e, o);
  $(document).on(e, o, c);
}

var backToTop = $('#backToTop');
$(window).on('scroll', function () {
  if ($(window).scrollTop() > 300) {
    backToTop.addClass('show');
  } else {
    backToTop.removeClass('show');
  }
});

backToTop.on('click', function (e) {
  e.preventDefault();
  $('html, body').animate(
    {
      scrollTop: 0,
    },
    '300'
  );
});

function mediaQueriesSupported() {
  return (
    typeof window.matchMedia != 'undefined' ||
    typeof window.msMatchMedia != 'undefined'
  );
}

trigger('click', '.submenu-toggler', function (e) {
  e.preventDefault();
  $('.submenu-menu').toggleClass('show');
  $('.submenu-toggler').toggleClass('collapsed');
});

trigger('click', 'a.scroll[href^="#"]', function (e) {
  var delta_container = '#nav-desktop';

  if (mediaQueriesSupported()) {
    if (window.matchMedia('(max-width: 768px)').matches) {
      delta_container = '#nav-mobile';
    }
  } else {
    if (window.width() <= 768) {
      delta_container = '#nav-mobile';
    }
  }
  var delta = $(delta_container).height() + 100;

  if (
    location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
    location.hostname == this.hostname
  ) {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
    if (target.length) {
      e.preventDefault();
      $('html, body').animate(
        {
          scrollTop: target.offset().top - delta,
        },
        1000,
        function () {
          $('.submenu-menu').removeClass('show');
          $('.submenu-toggler').addClass('collapsed');
        }
      );
    }
  }
});

$(function () {
  if (window.location.hash) {
    var target = $(window.location.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

    var delta_container = '#nav-desktop';

    if (mediaQueriesSupported()) {
      if (window.matchMedia('(max-width: 768px)').matches) {
        delta_container = '#nav-mobile';
      }
    } else {
      if (window.width() <= 768) {
        delta_container = '#nav-mobile';
      }
    }
    var delta = $(delta_container).height() + 100;

    if (target.length) {
      $('html, body').animate(
        {
          scrollTop: $(target).offset().top + delta,
        },
        500,
        function () {
          $('.submenu-menu').removeClass('show');
          $('.submenu-toggler').addClass('collapsed');
        }
      );
    }

    $(document.body).prepend(
      '<div id="page-loading-overlay"><div class="loader"></div></div>'
    );
  }

  $('.slider').each(function (index, element) {
    var slide = $(this);
    var section = slide.data('section');
    var slidetoshow = slide.data('slide');
    $(this).slick({
      slidesToShow: slidetoshow,
      autoplay: true,
      dots: false,
      arrows: true,
      infinite: true,
      speed: 500,
      /*centerMode: false,
      variableWidth: true,
      adaptiveHeight: true,*/
      prevArrow: '.prev-' + section,
      nextArrow: '.next-' + section,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  });
});

//#endregion

function add_overlay() {
  var $body = $('body');
  $body.addClass('page-loading-overlay');
  return false;
}

function remove_overlay() {
  var $body = $('body');
  $body.removeClass('page-loading-overlay');
  return false;
}

function isEmail(emailStr) {
  var x = emailStr.toLowerCase();
  var filter =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (filter.test(x)) return true;
  else return false;
}

const loadScript = (FILE_URL, async = true, type = 'text/javascript') => {
  return new Promise((resolve, reject) => {
    try {
      const scriptEle = document.createElement('script');
      scriptEle.type = type;
      scriptEle.async = async;
      scriptEle.src = FILE_URL;

      scriptEle.addEventListener('load', (ev) => {
        resolve({ status: true });
      });

      scriptEle.addEventListener('error', (ev) => {
        reject({
          status: false,
          message: `Failed to load the script ＄{FILE_URL}`,
        });
      });

      document.body.appendChild(scriptEle);
    } catch (error) {
      reject(error);
    }
  });
};

loadScript('https://www.google.com/recaptcha/api.js?hl=it&render=' + gapi_key)
  .then((data) => {
    console.log('Script loaded successfully', data);
  })
  .catch((err) => {
    console.error(err);
  });

trigger('click', '#btn-send', function (e) {
  submit_data();
});

function submit_data() {
  var error = '',
    form_error = 'Errore in fase di compilazione:';

  var nome = $.trim($('#frm_contact #nome').val());
  var cognome = $.trim($('#frm_contact #cognome').val());
  var telefono = $.trim($('#frm_contact #telefono').val());
  var email = $.trim($('#frm_contact #email').val());
  var attivita = $.trim($('#frm_contact #attivita option:selected').val());
  var messaggio = $.trim($('#frm_contact #messaggio').val());

  if (nome == '') error += 'Nome obbligatorio<br>';
  if (cognome == '') error += 'Cognome obbligatorio<br>';
  if (telefono == '') error += 'Telefono obbligatorio<br>';
  if (attivita == '') error += "Atticvita' obbligatoria<br>";
  if (email == '') {
    error += 'Email obbligatoria<br>';
  } else {
    if (!isEmail(email)) error += 'Email verificare indirizzo<br>';
  }
  //if (messaggio == '') error += 'Messaggio obbligatorio<br>';
  if (!$('#privacy').is(':checked'))
    error += 'Accettazione Privacy obbligatoria<br>';

  if (error == '') {
    add_overlay();

    grecaptcha.ready(function () {
      grecaptcha.execute(gapi_key, { action: 'frm_contact' }).then(
        function (token) {
          if (token) {
            add_overlay();

            var params = {
              recaptcha: token,
              nome: nome,
              cognome: cognome,
              telefono: telefono,
              email: email,
              attivita: attivita,
              messaggio: messaggio,
            };

            $.ajax({
              type: 'POST',
              cache: false,
              dataType: 'json',
              url:
                $('#frm_contact').data('execute') +
                '&q=' +
                Math.round(new Date().getTime()),
              data: params,
              success: function (data) {
                console.log('data', data);
                if (data.result) {
                  $(
                    '#frm_contact select, #frm_contact textarea, #frm_contact input:not([type=hidden])'
                  ).val('');
                  $('#frm_contact #privacy').prop('checked', false);
                  messaggio =
                    '<p>Invio completato correttamente.</p><p>Sarete ricontattati da un nostro incaricato non appena possibile</p>';
                } else {
                  messaggio =
                    '<p>Errore in fase di invio messaggio.</p><p>Si prega riprovare più tardi</p>' +
                    '<p>Qualora il problema dovesse persistere vi preghiamo contattatare direttamente <a href="mailto:info@ladybird.it">info@ladybird.it</a></p>';
                }

                bb_alert('Invio Messaggio', messaggio, 'Chiudi');

                remove_overlay();
              },
              error: function (xhr, ajaxOptions, thrownError) {
                remove_overlay();
                bb_alert(
                  form_error,
                  xhr.status + ' - ' + thrownError,
                  'Chiudi e riprova più tardi'
                );
              },
              async: true,
            });
          }
        },
        function (reason) {
          bb_alert(form_error, reason, 'Chiudi e Verifica');
        }
      );
    });
  } else {
    remove_overlay();
    bb_alert(form_error, error, 'Chiudi e Completa');
  }
  return false;
}

function bb_alert(title, message, label) {
  bootbox.alert({
    title: title,
    message: message,
    centerVertical: true,
    buttons: {
      ok: {
        label: label,
        className: 'btn-dark',
      },
    },
  });
  return false;
}
